import { GetFtpSettingsRequest, SaveFtpSettingsRequest } from 'entities/Integrations/api/types';
import { axiosInstance } from 'shared/config/axios';
import { getAccessToken } from 'shared/helpers/getAccessToken';

export const getFtpSettings: GetFtpSettingsRequest = () => {
	return axiosInstance.get('/ftp/settings', {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
	});
};
export const saveFtpSettings: SaveFtpSettingsRequest = (data) => {
	return axiosInstance.post('/ftp/settings', data, {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
	});
};
